import React from "react";
import FolderContainer from "./FolderContainer";
import {
	useHistory,
	useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import {useSelector} from "react-redux";

// Accounting tabs and the permission each needs (super sees all of them).
export const ACCOUNTING_TABS = [
	{name: "Billing", path: "/accounting/billing", permission: "manageReports"},
	{name: "Payroll", path: "/accounting/payroll", permission: "managePayroll"},
	{name: "Adjustments", path: "/accounting/adjustment", permission: "manageReports"},
];

export const useAccountingTabs = () => {
	const user = useSelector(state => state.current.user);
	const permissions = useSelector(state => state.current.permissions) || [];
	if (user?.accountType === "super") return ACCOUNTING_TABS;
	return ACCOUNTING_TABS.filter(t => permissions.includes(t.permission));
};

const AccountingFolderContainer = ({children}) => {
	const history = useHistory();
	const location = useLocation();
	const tabs = useAccountingTabs();

	const user = useSelector(state => state.current.user);

	const treatClient = user.accountType === "client";
	if (treatClient) return <FolderContainer>{children}</FolderContainer>;
	const selected = location.pathname.includes("payroll")
		? "Payroll"
		: location.pathname.includes("billing")
		? "Billing"
		: "Adjustments";
	return (
		<FolderContainer
			tabs={tabs.map(t => t.name)}
			onTab={v => history.push(tabs.find(t => t.name === v).path)}
			selectedTab={selected}
		>
			{children}
		</FolderContainer>
	);
};

// /accounting: the first tab this person can open
export const AccountingHome = () => {
	const history = useHistory();
	const user = useSelector(state => state.current.user);
	const tabs = useAccountingTabs();
	React.useEffect(() => {
		if (!user?._id) return; // still loading
		if (user.accountType === "client") return history.replace("/accounting/billing");
		history.replace(tabs[0]?.path || "/dashboard");
	}, [user, tabs, history]);
	return null;
};

export default AccountingFolderContainer;
